var exports = {
  "vK": "x8b4e8595--a268fc--banner",
  "EY": "x8b4e8595--a268fc--custom-content",
  "Sl": "x8b4e8595--a268fc--image",
  "DD": "x8b4e8595--a268fc--title",
  "VA": "x8b4e8595--a268fc--subtitle",
};

module.exports = exports;
